import { SelectReducerActions } from './types';
import { SelectOptionType } from '../types';

const showOptions = (): SelectReducerActions => ({
  type: 'SHOW_OPTIONS',
});

const hideOptions = (): SelectReducerActions => ({
  type: 'HIDE_OPTIONS',
});

const setFilteredOptions = (
  options: SelectOptionType[]
): SelectReducerActions => ({
  type: 'SET_FILTERED_OPTIONS',
  payload: { options },
});

const setSearchPhrase = (searchPhrase: string): SelectReducerActions => ({
  type: 'SET_SEARCH_PHRASE',
  payload: { searchPhrase },
});

const setPlaceholder = (placeholder: string): SelectReducerActions => ({
  type: 'SET_PLACEHOLDER',
  payload: { placeholder },
});

const setSelectionIndex = (index: number | null): SelectReducerActions => ({
  type: 'SET_SELECTION_INDEX',
  payload: { index },
});

const toggleSelectionMode = (
  inSelectionMode: boolean
): SelectReducerActions => ({
  type: 'SET_SELECTION_MODE',
  payload: { inSelectionMode },
});

export const selectActions = {
  showOptions,
  hideOptions,
  setPlaceholder,
  setSearchPhrase,
  setFilteredOptions,
  setSelectionIndex,
  toggleSelectionMode,
};
